<template>
  <div class="login" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="register">
      <div class="title">
        账号登录
        <span v-if="loginSetting.isOpenRegister === 1" class="link" @click="$router.push({ name: 'register' })">
          还没有账号，去注册
          <img
            style="width: 8px; height: 14px; margin-left: 8px"
            src="../assets/right-icon.png"
            alt=""
          />
        </span>
      </div>
      <div class="input">
        <el-input
          class="password"
          :placeholder="loginSetting.usernamePlaceholder"
          v-model="form.phone"
        ></el-input>
      </div>
      <div class="username-tip">
        <!-- <img src="../assets/login-username-icon.png" alt="" />
        <p>若您已在其他平台报名注册过，登录所用的手机号及密码，请具体参见赛事官方发布的通知</p> -->
      </div>
      <div class="input">
        <el-input
          class="password"
          :type="isShow ? 'text' : 'password'"
          :placeholder="loginSetting.passwordPlaceholder"
          v-model="form.password"
        ></el-input>
        <div
          style="
            width: 30px;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
          @click="isShow = !isShow"
        >
          <img
            src="../assets/eye-0.png"
            v-if="!isShow"
            style="width: 20px; height: 16px"
            alt=""
          />
          <img
            src="../assets/eye-1.png"
            v-else
            style="width: 20px; height: 14px"
            alt=""
          />
        </div>
      </div>
      <p class="error">{{ error }}</p>
      <el-checkbox class="checkbox" v-model="checked">
        我已认真阅读并同意
      </el-checkbox>
      <a
        class="file"
        href="javascript:;"
        @click="
          onViewPdf(loginSetting.platformUserAgreementUrl, '平台用户协议')
        "
      >
        《平台用户协议》
      </a>
      <a
        class="file"
        href="javascript:;"
        @click="onViewPdf(loginSetting.privacyStatement, '隐私保护声明')"
      >
        《隐私保护声明》
      </a>
      <p class="login-btn" @click="login">登录</p>
      <p class="tip">
        {{ loginSetting.tips }}
      </p>
    </div>

    <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      :custom-class="'work-dialog'"
      fullscreen
      @close="onWorkDialogClose"
    >
      <PdfViewer :key="pdfUrl" :pdf-url="pdfUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { login } from "../api/login";
import { getSiteConfig } from "@/api/common";
import PdfViewer from "@/components/pdf-viewer";

export default {
  name: "Login",
  components: { PdfViewer },
  data() {
    return {
      dialogTitle: "",
      visible: false,
      isActive: true,
      isShow: false,
      fullscreenLoading: false,
      checked: false,
      form: {
        phone: "",
        password: "",
      },
      error: "",
      loginSetting: {},
      pdfUrl: "",
    };
  },
  created() {
    this.getSiteConfig();
  },
  methods: {
    onWorkDialogClose() {},
    onViewPdf(pdfUrl, title) {
      this.pdfUrl = pdfUrl;
      this.dialogTitle = title;
      this.visible = true;
    },
    getSiteConfig() {
      getSiteConfig().then(({ data }) => {
        this.loginSetting = data.login;
      });
    },
    login() {
      if (!this.form.phone) {
        return (this.error = "请输入参赛选手报名手机号");
      }
      if (!this.form.password) {
        return (this.error = "请输入参赛选手完整证件号");
      }
      if (!this.checked) {
        return (this.error = "请阅读协议");
      }

      this.error = "";
      login(this.form).then((res) => {
        localStorage.setItem("TOKEN", res.data.authToken);
        let userInfo = {
          id: res.data.id,
          phone: res.data.phone,
          nickname: res.data.nickname,
        };
        localStorage.setItem("USERINFO", JSON.stringify(userInfo));
        if (this.$route.query.type === 1) {
          this.$router.push({
            path: "/",
          });
        } else {
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .work-dialog .el-dialog__body {
  height: calc(100vh - 54px);
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
}

.code {
  width: 74px;
  height: 32px;
  background: #046bde;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  cursor: pointer;
}
.tip {
  font-size: 14px;
  font-weight: 400;
  color: #788a9f;
  line-height: 21px;
  margin-top: 24px;
}
.login-btn {
  width: 400px;
  height: 40px;
  background: #046bde;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin-top: 32px;
  cursor: pointer;
}
.checkbox {
  margin-top: 40px;
}
.file {
  font-size: 14px;
  font-weight: 400;
  color: #046bde;
  line-height: 22px;
}
.error {
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #f95155;
  line-height: 14px;
  margin: 8px 0 0 24px;
}
.username-tip {
  display: flex;
  margin: 10px 0;
}
.username-tip img {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-right: 5px;
}
.username-tip p {
  font-size: 14px;
  font-weight: 400;
  color: #788a9f;
  line-height: 21px;
}
.username {
  margin-top: 40px;
}
.login {
  width: 100%;
  height: 100vh;
  background: #171f30;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 100px 0;
}
.background-style {
  background-color: #171f30; /* 设置背景颜色 */
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;
}
.register {
  width: 520px;
  height: 592px;
  border: 1px solid #046bde;
  border-radius: 20px;
  padding: 90px 60px 50px;
}
.link {
  font-weight: 400;
  font-size: 16px;
  color: #046bde;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
}
.title {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 30px;
  margin-bottom: 40px;
  display: flex;
}
::v-deep .el-input__inner {
  background: transparent;
  border: none !important;
  /* color: #fff; */
  font-size: 16px !important;
  font-weight: 400;
  color: #909399;
  line-height: 16px;
}
.input {
  font-size: 16px !important;
  font-weight: 400;
  color: #909399;
  line-height: 16px;
  background: #0a2b51 !important;
  border-radius: 25px !important;
  border: 1px solid #046bde !important;
  height: 50px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
